class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      let inputUpdate = cartItems.querySelector('input.quantity__input');
      let idPdpTryBuy = Number(inputUpdate.getAttribute('data-trybuy-variant'));
      let isUpdateProductTry = false;
      if(idPdpTryBuy && document.querySelector(`input[data-quantity-variant-id="${idPdpTryBuy}"]`)) {
        isUpdateProductTry = true;
      }
      cartItems.updateQuantity(this.dataset.index, 0, null, isUpdateProductTry, idPdpTryBuy);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      let idPdpTryBuy  = event.target.dataset?.trybuyVariant || null;
      let isUpdateProductTry = false;

      if(idPdpTryBuy && document.querySelector(`input[data-quantity-variant-id="${idPdpTryBuy}"]`)) {
        isUpdateProductTry = true;
      }

      this.onChange(event, isUpdateProductTry, idPdpTryBuy);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event, isUpdateProductTry = false, idPdpTryBuy = null) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      isUpdateProductTry,
      idPdpTryBuy
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name,  isUpdateProductTry, idPdpTryBuy) {
    this.enableLoading(line);
    let totalPrice = 0;
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");


        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          if(window.page == 'cart') {
            if(elementToReplace.querySelector('.totals__subtotal-value-cart-page')?.getAttribute('data-total-cart')) {
              totalPrice = parseFloat(elementToReplace.querySelector('.totals__subtotal-value-cart-page')?.getAttribute('data-total-cart'));
            }
          } else {
            if(elementToReplace.querySelector('.totals__subtotal-value')?.getAttribute('data-total-cart')) {
              totalPrice = parseFloat(elementToReplace.querySelector('.totals__subtotal-value')?.getAttribute('data-total-cart'));
            }
          }

          if(section.id == 'cart-icon-bubble') {
            let itemCount = 0;
            if(elementToReplace.querySelector('.cart-count-bubble')) {
              itemCount = elementToReplace.querySelector('.cart-count-bubble').querySelector('span[aria-hidden="true"]').innerHTML
            }
            document.querySelectorAll('.total-item').forEach(item => {
              item.innerHTML = itemCount;
            });
            if(itemCount > 0) {
              document.querySelectorAll('.is-empty').forEach(item => {
                item.classList.remove('is-empty')
              })
            }
          }
        });


        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        let updates = {};
        let isPdpRemove = false;

        if(isUpdateProductTry && idPdpTryBuy) {
          updates[idPdpTryBuy] = quantity;
          console.log('ProductTryRemove', idPdpTryBuy)
          isPdpRemove = true;
        }

        document.querySelectorAll('.btn-add-gift').forEach(item => {
          let priceUnlock = parseFloat(item.getAttribute('data-unlock_threshold'));
          if(priceUnlock < totalPrice) {
            item.disabled = false;
            if(document.querySelector('unlock-gift')) {
              let unlockGift = document.querySelector('unlock-gift');
              unlockGift.addEventAddGiftToCart(unlockGift);
            }
          } else {
            item.disabled = true;
            let elParent = item.closest('.item-gift');
            let idVariation = elParent.querySelector('.id-gift-add-cart').value;
            let cartItem = document.getElementById('CartDrawer');
            if(window.page == 'cart') {
              cartItem = document.getElementById('main-cart-items');
            }


            if(cartItem) {
              if(cartItem.querySelector(`.pdp-gift[data-id-vartion="${idVariation}"]`)) {
                isPdpRemove = true;
                updates[idVariation] = 0;
                console.log('gift-remove', idVariation)
                item.classList.remove('hidden');
                if(elParent.querySelector('.mess-has-add-to-cart')) {
                  elParent.querySelector('.mess-has-add-to-cart').classList.add('hidden');
                }
              }
            }
          }
        });

        if(isPdpRemove) {
          let setcion = this.getSectionsToRender().map((section) => section.section)
          if(window.page == 'cart') {
            let cartMain =  document.querySelector("cart-items");
            if(cartMain) {
              setcion = cartMain.getSectionsToRender().map((section) => section.section)
            }
          }

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates,
              sections: setcion,
              sections_url: window.location.pathname,
            })
          })
            .then(response => {
              return response.text();
            }).then(response => {
            const parsedState = JSON.parse(response);

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );

              if(section.id == 'cart-icon-bubble') {
                let itemCount = 0;
                if(elementToReplace.querySelector('.cart-count-bubble')) {
                  itemCount = elementToReplace.querySelector('.cart-count-bubble').querySelector('span[aria-hidden="true"]').innerHTML
                }
                document.querySelectorAll('.total-item').forEach(item => {
                  item.innerHTML = itemCount;
                });
                if(itemCount > 0) {
                  document.querySelectorAll('.is-empty').forEach(item => {
                    item.classList.remove('is-empty')
                  })
                }
              }

            });
          })
            .catch((error) => {
              console.error('Error:', error);
            });
        }


        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        // SE PUEDE MIRAR LA POSIBILIDAD DE QUE AL  ACTUALIZAR LA CANTIDAD DEL CARRITO NO SE ELIMINE EL SLIDER

        let mostExpensiveId = getMostExpensiveProductId();
        if (typeof mostExpensiveId == "string") {
          getProductRelated("gid://shopify/Product/" + mostExpensiveId);
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

if(document.querySelector('.shopify-section-discount #apply_discount')) {
  document.querySelector('.shopify-section-discount #apply_discount').addEventListener('click', function (event) {
    event.preventDefault()
    const elmMessages =  document.querySelector('.shopify-section-discount #discount_message')
    const elmInput = document.querySelector('.shopify-section-discount #discount_code')
    const elmRemoveDiscount = document.querySelector('.shopify-section-discount #remove_discount')
    const discountCode = document.querySelector('.shopify-section-discount #discount_code').value

    if (discountCode) {
      elmInput.classList.remove('error')
      elmMessages.classList.remove('error')
      elmMessages.classList.remove('hidden')

      document.querySelector('.shopify-section-discount #discount_form_code').value = discountCode

      elmMessages.innerText = window.translate.message_process_apply

      fetch('/discount/' + encodeURIComponent(discountCode), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Accept': "*/*",
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
        }
      }).then(function (response) {
        return response;
      }).then(function (data) {
          if (data.status === 200) {
            checkApplyDiscount();
          } else {
            alert('Invalid discount code. Please try again.');
          }
      }).finally(function () {
        console.log('successfully');
      });
    } else {
      elmMessages.innerText = window.translate.field_required
      elmMessages.classList.remove('hidden')
      elmMessages.classList.add('error')
      elmInput.classList.add('error')
      elmRemoveDiscount.classList.add('hidden')
    }
  })
}

if(document.querySelector('.shopify-section-discount #remove_discount')) {
  document.querySelector('.shopify-section-discount #remove_discount').addEventListener('click', function (event) {
    event.preventDefault();
    const elmMessages =  document.querySelector('.shopify-section-discount #discount_message')
    const elmBtnSubmit = document.querySelector('.shopify-section-discount #apply_discount')
    const elmInput = document.querySelector('.shopify-section-discount #discount_code')
  
    document.querySelector('.shopify-section-discount #discount_form_code').value = ''
    elmMessages.innerText = window.translate.message_process_remove
    fetch('/discount/null', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
          'Accept': "*/*",
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
      }
    }).then(function (response) {
      return response;
    }).then(function (data) {
        if (data.status === 200) {
          checkApplyDiscount()
        } else {
          alert('Invalid discount code. Please try again.')
        }
    }).finally(function () {
      console.log('successfully')
    })

    elmMessages.innerText = window.translate.message_remove_success
    document.querySelector('.shopify-section-discount #remove_discount').classList.add('hidden')
    setTimeout(() => {
      elmMessages.classList.add('hidden')
    }, 2000)

    elmInput.value = ''
    elmBtnSubmit.removeAttribute('disabled')
  })
}

function checkApplyDiscount() {
  fetch("/cart.js")
  .then(result => {return result.json()})
  .then(function (result) {
    if(result) {
      const elmMessages =  document.querySelector('.shopify-section-discount #discount_message')
      const elmRemoveDiscount = document.querySelector('.shopify-section-discount #remove_discount')
      const elmBtnSubmit = document.querySelector('.shopify-section-discount #apply_discount')

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if(cart.total_discount > 0) {
            // Discount valid
            elmMessages.innerText = window.translate.message_apply_success
            elmRemoveDiscount.classList.remove('hidden')

            elmBtnSubmit.setAttribute('disabled', true)

          } else {
            // Discount invalid
            elmMessages.innerText = window.translate.message_discount_invalid
            elmRemoveDiscount.classList.add('hidden')
          }

          setTimeout(() => {
            elmMessages.classList.add('hidden')
          }, 2000)

          // refresh cart
          fetch(`${routes.cart_url}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            document.querySelector('.main-cart-footer .js-contents').innerHTML = html.querySelector('.cart__footer .js-contents').innerHTML
          })
          .catch((e) => {
            console.error(e);
          });
        })
        .catch(error => console.error('Error fetching cart details:', error))
    }
  })
}
